<template>
  <div class="PortfolioSelect">
    <Multiselect
      :value="value"
      :options="availableOptions"
      class="multiselect--with-glass"
      :class="{ 'multiselect--empty': availableOptions.length === 0, 'multiselect--loading': isLoading }"
      :showNoResults="false"
      :localSearch="false"
      :multiple="multiple"
      :internalSearch="true"
      :hideSelected="true"
      :loading="isLoading"
      :placeholder="placeholder"
      trackBy="uid"
      label="name"
      @input="p => $emit('input', p)"
      @search-change="search"
    />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import getThrottle from "@synbioz/throttle";
import getAPIClient from "../getAPIClient";

const throttle = getThrottle();
let api;

export default {
  props: {
    value: {
      type: null,
      default: () => []
    },
    authHost: {
      type: String,
      required: true
    },
    minLengthSearch: {
      type: Number,
      default: 3
    },
    multiple: {
      type: Boolean,
      default: false
    },
    excluded: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isLoading: false,
      options: []
    };
  },

  computed: {
    placeholder() {
      return `Search a portfolio...${this.minLengthSearch ? " (" + this.minLengthSearch + "char min)" : ""}`;
    },
    availableOptions() {
      return this.options.reduce((acc, result) => this.excluded.find(p => p.uid === result.uid) ? acc : [result, ...acc], []);
    }
  },
  methods: {
    search(query) {
      if (query.length < this.minLengthSearch) {
        return;
      }
      throttle(async() => {
        this.isLoading = true;
        this.options = await api.searchPortfolio(query);
        this.isLoading = false;
      }, 700);
    }
  },
  created() {
    api = getAPIClient(this.authHost, this.$auth.fetch);
    if (this.value) {
      this.options = this.multiple ? this.value : [this.value];
    }
  },
  components: { Multiselect }
};
</script>
